import asyncComponent from '../common/utils/async-component.js';

const IndexLog = asyncComponent(async () => import('./components/index.js'));

export default {
  '/api/index-log': {
    components: { main: IndexLog }
  }
};
